import Vue from 'vue'
// import {router} from './index'
//公共页面
import login from '@/views/login/login'
import phone from '@/views/login/phone'
import agentInfo from '@/views/agentLogin/agentInfo'
import transfer from '@/views/login/transfer'
import productDetails from '@/views/commonPage/productDetails'
import collection from '@/views/commonPage/collection'
import error from '@/views/login/other'
import myOrder from '@/views/commonPage/myOrder'
import myOrderDetails from '@/views/commonPage/myOrderDetails'

//普通用户对应页面
import index from '@/views/home/index'
import productList from '@/views/product/productList'
import myInfo from '@/views/my/myInfo'
import myDialog from '@/views/my/myDialog'
// import myOrder from '@/views/my/myOrder'
// import myOrderDetails from '@/views/my/myOrderDetails'

// 经销商、渠道对应页面
import agentProductList from '@/views/agentProduct/agentProductList'
import agentMy from '@/views/agentMy/agentMy'//个人中心
import clientInfo from '@/views/agentMy/clientInfo'
import noteInfo from '@/views/agentMy/noteInfo'
import totalPremium from "@/views/agentMy/totalPremium"

export let initMenu =[
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登陆页面',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要
        },
        component: login
      },
      {
        path: '/phone',
        name: 'phone',
        meta: {
            title: '普通用户完善信息',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要
        },
        component: phone
      },
      {
        path: '/agentInfo',
        name: 'agentInfo',
        meta: {
            title: '经纪人完善信息',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要
        },
        component: agentInfo
      },
      {
        path: '/transfer',
        name: 'transfer',
        meta: {
            title: '微信跳转页面',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要
        },
        component: transfer
      },
      
      {
        path: '/productDetails',
        name: 'productDetails',
        meta: {
            title: '详情页',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要pjh
        },
        component: productDetails
      },
      {
        path: '/collection',
        name: 'collection',
        meta: {
            title: '我的收藏',
            requireAuth:true,//是否需要登陆验证，true是，false，不需要
        },
        component: collection
      },
      {
        path: '/error',
        name: 'error',
        meta: {
            title: '404',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要
        },
        component: error
      },
      {
        path: '/myOrder/:id',
        name: 'myOrder',
        meta: {
            title: '我的订单',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要
        },
        component: myOrder
    },
    {
        path: '/myOrderDetails',
        name: 'myOrderDetails',
        meta: {
            title: '订单详情',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要
        },
        component: myOrderDetails
    },
];
//2普通用户对应页面
export let menu2=[
    {
        path: '/',
        name: 'index',
        meta: {
            title: '首页',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要pjh
        },
        component: index
    },
    {
        path: '/productList',
        name: 'productList',
        meta: {
            title: '产品库',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要pjh
        },
        component: productList
    },
    {
        path: '/myInfo',
        name: 'myInfo',
        meta: {
            title: '我的',
            requireAuth:false,//是否需要登陆验证，true是，false，不需要pjh
        },
        component: myInfo
    },
    {
        path: '/myDialog',
        name: 'myDialog',
        meta: {
            title: '理赔弹窗页',
            requireAuth:true,//是否需要登陆验证，true是，false，不需要
        },
        component: myDialog
    },
    
];
// 经销商、渠道对应页面
export let menu1=[
    {
        path: '/',
        name: 'agentProductList',
        meta: {
            title: '产品管理',
            requireAuth:true,//是否需要登陆验证，true是，false，不需要
        },
        component: agentProductList
    },
    {
        path: '/agentMy',
        name: 'agentMy',
        meta: {
            title: '客户管理',
            requireAuth:true,//是否需要登陆验证，true是，false，不需要
        },
        component: agentMy
    },
    {
        path: '/clientInfo',
        name: 'clientInfo',
        meta: {
            title: '客户信息',
            requireAuth:true,//是否需要登陆验证，true是，false，不需要
        },
        component: clientInfo
    },
    {
        path: '/noteInfo',
        name: 'noteInfo',
        meta: {
            title: '备注',
            requireAuth:true,//是否需要登陆验证，true是，false，不需要
        },
        component: noteInfo
    },
    {
        path: '/totalPremium',
        name: 'totalPremium',
        meta: {
            title: '保费合计',
            requireAuth:true,//是否需要登陆验证，true是，false，不需要
        },
        component: totalPremium
    },
];
export const routers = {
    router: initMenu
}  


// WEBPACK FOOTER //
// ./src/router/router.js